import { getData, getDataforUrl, postFormData } from "./index";

export const termsConditionsList = async (payload) => {
  return getData("admin/termsConditionsList", payload).then((data) => data);
};

export const termsConditionsDetails = async (payload) => {
  return getDataforUrl("admin/getTermsConditionsDetails", payload).then(
    (data) => data
  );
};

export const addTermsConditions = async (payload) => {
  return postFormData("admin/addTermsConditions", payload).then((data) => data);
};
